import React, { PureComponent } from 'react';
import cn from 'classnames';
import { convertPxToVw } from 'common/utils/helpers';
import { IframeTunnel } from 'common/utils/iframe-tunnel';
import { IFRAME_ACTIONS, CARD_ROOT_ELEMENT_INDEX, COMPONENT_TYPE } from 'common/constants';
import RelativeSizeValue from 'client/components/common/RelativeSizeValue';
import css from './ContentResize.scss';

// TODO think about transmit refactor for a whole client app (centralized transmitter as in admin)
function transmitUpdatedValueToAdmin({ path, value, isStory }) {
	const iframeTunnel = new IframeTunnel({ id: 'ContentResize' });
	iframeTunnel.messageTransmitter({
		target: IframeTunnel.targets.admin,
		action: isStory ? IFRAME_ACTIONS.UPDATE_STORY_ELEMENT_BY_PATH : IFRAME_ACTIONS.UPDATE_CARD_ELEMENT_BY_PATH,
		payload: {
			path,
			value,
		},
	});
}

const initialState = {
	isDragging: false,
	isSnap: false,
	startH: 0,
	startY: 0,
	deltaY: 0,
	debug: false,
};

type OwnState = any;

type State = OwnState & typeof ContentResize.defaultProps;

type Props = {
	setDragging: (...args: any[]) => any;
	currentMediaQuery: string;
	currentState: string;
	contentHeight?: string;
};

class ContentResize extends PureComponent<Props, State> {
	static defaultProps = {
		contentHeight: '',
	};

	state = initialState;

	constructor(props, context) {
		super(props, context);
		// @ts-expect-error ts-migrate FIXME
		this.contentNodeSelector = `[data-bb="${COMPONENT_TYPE.CONTENT}"`;
		// @ts-expect-error ts-migrate FIXME
		this.interval = null;
		// @ts-expect-error ts-migrate FIXME
		this.intervalIncrement = 10;
		// @ts-expect-error ts-migrate FIXME
		this.intervalTimeout = 50;
	}

	componentDidUpdate(prevProps: any) {
		// @ts-expect-error ts-migrate FIXME
		if (this.state.isSnap && !this.interval) {
			this.setInterval();
		}

		if (this.props.contentHeight !== prevProps.contentHeight) {
			this.contentNode.style.height = ''; // reset inline styles to use relevant from css
		}
	}

	get contentNode() {
		// @ts-expect-error ts-migrate FIXME
		return document.querySelector(this.contentNodeSelector);
	}

	listeners = (action = 'add') => {
		document[`${action}EventListener`]('mouseup', this.onMouseUp);
		document[`${action}EventListener`]('mousemove', this.onMouseMove);
	};

	/**
	 * Increment deltaY automatically when mouse position is of out the required viewport bounds limits
	 */
	setInterval = () => {
		// @ts-expect-error ts-migrate FIXME
		this.interval = setInterval(() => {
			this.setState(prevState => {
				return {
					// @ts-expect-error ts-migrate FIXME
					deltaY: prevState.deltaY + this.intervalIncrement,
				};
			}, this.update);
			// @ts-expect-error ts-migrate FIXME
		}, this.intervalTimeout);
	};

	clearInterval = () => {
		// @ts-expect-error ts-migrate FIXME
		if (this.interval) {
			// @ts-expect-error ts-migrate FIXME
			clearInterval(this.interval);
			// @ts-expect-error ts-migrate FIXME
			this.interval = null;
		}
	};

	onMouseDown = ({ clientY: startY }) => {
		const startH = this.contentNode.clientHeight;

		this.props.setDragging(true);

		this.setState(
			{
				isDragging: true,
				startY,
				startH,
			},
			this.listeners
		);
	};

	onMouseMove = ({ pageY, clientY }) => {
		const { startY } = this.state;
		const deltaY = clientY - startY;
		const viewportDelta = window.innerHeight - clientY;
		const SNAP_BOUND = 15;

		// set interval (see componentDidUpdate lifecycle)
		// @ts-expect-error ts-migrate FIXME
		if (viewportDelta < SNAP_BOUND && !this.interval) {
			this.setState({
				deltaY,
				isSnap: true,
			});
			return;
		}

		// clear interval
		// @ts-expect-error ts-migrate FIXME
		if (this.interval) {
			if (viewportDelta > SNAP_BOUND) {
				this.clearInterval();
				this.setState(
					{
						isSnap: false,
						startH: this.contentNode.clientHeight,
						startY: clientY,
						deltaY: 0,
					},
					this.update
				);
			}
			return;
		}

		// default move
		this.setState({ deltaY }, this.update);
	};

	onMouseUp = () => {
		this.clearInterval();
		this.props.setDragging(false);
		this.listeners('remove');
		this.setState(initialState);

		// transmitToAdmin ...
		const index = CARD_ROOT_ELEMENT_INDEX[COMPONENT_TYPE.CARD];
		const { currentMediaQuery, currentState } = this.props;
		// @ts-expect-error ts-migrate FIXME
		transmitUpdatedValueToAdmin({
			path: `elements.${index}.uiConfig.componentProps.other.${currentState}.${currentMediaQuery}.contentHeight`,
			value: this.contentNode.style.height,
		});
	};

	update = () => {
		this.contentNode.style.height = convertPxToVw(this.state.startH + this.state.deltaY);

		// Update scroll position
		const { scrollHeight, clientHeight } = document.documentElement;
		document.documentElement.scrollTop = Math.max(scrollHeight - clientHeight, 0);
	};

	render() {
		const { isDragging } = this.state;
		return (
			<div
				draggable={false}
				onMouseDown={this.onMouseDown}
				className={cn(css.handle, { [css.dragging]: isDragging })}
			>
				<span className={css.label}>
					{/* @ts-expect-error ts-migrate FIXME */}
					{isDragging ? <RelativeSizeValue value={this.contentNode.clientHeight} unit=" px" /> : ''}
				</span>
			</div>
		);
	}
}

export default ContentResize;
